import { Alert } from 'antd';
import { EyeOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { semantic } from '@/theme/tokens';

/**
 * S4-T16 — Banner shown at the top of every page when `?ro=1` is set.
 *
 * Renders inside AppShell above the Content so the user immediately
 * understands why FABs and Add buttons are missing.
 */
export default function ReadOnlyBanner() {
  const { t } = useTranslation('common');
  return (
    <Alert
      type="info"
      showIcon
      icon={<EyeOutlined />}
      banner
      message={t('readOnly.bannerTitle')}
      description={t('readOnly.bannerDescription')}
      className="ga-no-print"
      style={{
        background: 'rgba(184, 137, 62, 0.08)',
        borderBottom: `1px solid ${semantic.brand.accent}40`,
        color: semantic.brand.primary,
      }}
    />
  );
}
